import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  Fragment,
} from 'react';
import { useDisclosure } from '@chakra-ui/hooks';
import { Box, Flex, Spinner, Text, Avatar } from '@chakra-ui/react';
import IsDesktop from '../../utils/IsDesktop';
import client from '../../libs/client';
import { BASE_URL } from '../../helpers/constant';
import { useData } from '../../data';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useInterval } from '../../utils/useInterval';
import { Select } from 'antd';
import NewFilter from '../filter/NewFilter';
import dashboard from '../../public/icons/dashboard.svg';
import { useNavigate } from 'react-router-dom';
import NewSingleInvestor from './NewSingleInvestor';
import BrandButton from '../brandButton/BrandButton';
import Collapsible from '../collapsible/collapsible';
import PaginationControls from '../PaginationControls';

const InvestorList = ({ showViewAll = false }) => {
  const { isOpen, onToggle } = useDisclosure();
  const [selectedFounder, setSelectedFounder] = useState({});
  const isDesktop = IsDesktop();
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(20);
  const [totalUsers, setTotalUsers] = useState(0);
  const [investors, setInvestors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilters] = useState({});
  const [selectedUserIndex, setSelectedUserIndex] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const { isOpen: viewDetailsIsOpen, onToggle: onToggleViewDetails } =
    useDisclosure();
  const loggedInUser = useSelector((state) => state?.user?.userInfo);
  const chatWithUserState = useSelector((state) => state?.chat?.chatInfo);
  const [recipient, setRecipient] = useState(chatWithUserState);
  const [recipientId, setRecipientId] = useState(chatWithUserState?.id);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);
  const [showMessageTray, setShowMessageTray] = useState(false);
  const { data } = useData('survey');
  const [filterIsActive, setFilterIsActive] = useState(false);
  const [resetFilters, setResetFilters] = useState(false);

  const [searchInput, setSearchInput] = useState('');
  const [searchData, setSearchData] = useState([]);
  const { OptGroup } = Select;

  // const { data, isLoading, refetch } = useData(`messages`);
  const [connections, setConnections] = useState([]);
  const {
    data: connectionsData,
    isLoading: connectionsLoading,
    refetch: refetchConnections,
  } = useData(
    `users/${loggedInUser?.id}/connections?page_no=1&page_size=10`,
    30000,
  );
  const {
    isOpen: chatBoxIsOpen,
    onOpen: onOpenChatBox,
    onClose: onCloseChatBox,
    onToggle: onToggleChatBox,
  } = useDisclosure();
  const investorsContainerRef = useRef(null);

  const loggedInUserSubscription = useSelector(
    (state) => state?.user?.userSubscriptionInfo,
  );
  const SUBSCRIPTION_FLAG = process.env.REACT_APP_SUBSCRIPTION_FLAG;

  const loggedInUserType = loggedInUser?.userTypeTitle;
  const currentPlanName = loggedInUserSubscription?.subscription_plan?.name;

  const isFreePlan = currentPlanName?.toLowerCase().includes("free");


  const navigate = useNavigate();

  useEffect(() => {
    if (connectionsData?.data) {
      setConnections(
        connectionsData?.data?.connections?.sort((a, b) =>
          moment(b?.lastMessage?.createdAt || b?.connection?.created_at).diff(
            moment(a?.lastMessage?.createdAt || a?.connection?.created_at),
          ),
        ),
      );
    }
    if (chatWithUserState) {
      openChatBox(chatWithUserState?.id, chatWithUserState);
    }
  }, [connectionsData?.data?.connections, chatWithUserState]);

  const openMessageTray = () => {
    setShowMessageTray((prev) => !prev);
  };

  const openChatBox = (recipientId, recipient) => {
    setRecipientId(recipientId);
    setRecipient(recipient);
    onOpenChatBox();
  };
  const closeChatBox = () => {
    setRecipientId(null);
    setRecipient(null);
    onToggleChatBox();
  };
  const isFromNavigate = () => {
    return (
      chatWithUserState &&
      chatWithUserState?.id === recipientId &&
      chatWithUserState?.connection?.accepted
    );
  };
  useInterval(() => {
    refetchConnections();
  }, 15000);

  const searchConnections = useCallback(
    (inputValue) => {
      setIsLoadingMessages(true);
      if (inputValue !== '') {
        setSearchData(
          connections?.filter((connection) =>
            `${connection?.first_name} ${connection?.last_name}`
              .toLowerCase()
              .includes(inputValue.toLowerCase()),
          ),
        );
      }
      setIsLoadingMessages(false);
    },
    [connections],
  );

  const searchResults = searchData?.map((user) => (
    <Select.Option key={user.id}>
      <Flex alignItems="center">
        <Avatar
          size="sm"
          name={`${user.first_name} ${user.last_name}`}
          src={user.profile_image}
        />
        <Text ml={4}>{`${user.first_name} ${user.last_name}`}</Text>
      </Flex>
    </Select.Option>
  ));

  const openSearchedUserChatBox = (userId) => {
    setRecipientId(userId);
    setRecipient(
      connections?.find(
        (connection) => connection?.id?.toString() === userId.toString(),
      ),
    );
    onOpenChatBox();
  };



  const updateFilter = (data) => {
    setFilters((prev) => ({
      ...prev,
      ...data,
    }));
  };

  const handleFilterChange = (data) => {
    if (SUBSCRIPTION_FLAG == "on" && isFreePlan) {
      navigate(`${window.location.pathname}?upgrade=true`, { replace: true });
    } else {
      updateFilter(data);
    }
  }


  const handleResetFilter = () => {
    setResetFilters(true);
  };

  useEffect(() => {
    let status = false;
    for (let key of Object.keys(filter)) {
      if (filter[key]?.length > 0) {
        status = true;
        break;
      }
    }
    setFilterIsActive(status);
    setResetFilters(false);
  }, [filter]);

  const updateState = (data) => {
    setIsLoading(false);
    setInvestors(data);
  };

  const parseFilters = (obj) => {
    const params = {
      companyStages: 'company_stage',
      fundCategories: 'fund_category',
      locations: 'incorporation_location',
      businessModels: 'business_model',
      categories: 'business_category',
    };
    return Object.entries(obj)
      .map(([key, val]) => `${params[key]}=${encodeURIComponent(val)}`)
      .join('&');
  };

  const isRestricted = SUBSCRIPTION_FLAG == "on" && isFreePlan && loggedInUserType === 'founder' ? true : false;
  const getInvestors = ({ filters = filter, pageNumber = 1 }) => {
    const _filters = parseFilters(filters);
    return client()
      .get(
        `${BASE_URL}user-types/investor?page_no=${pageNumber}&page_size=${pageSize}&restrict=${isRestricted ? 'true' : 'false'}${_filters ? `&${_filters}` : ''}`,
      )
      .then((res) => {
        setIsLoading(true);
        let data = res.data.data.users;
        setTotalUsers(res.data.data.totalUsers);
        updateState(data);
      });
  };

  useEffect(() => {
    getInvestors({});
  }, []);

  const onSelectUser = (id) => {
    setSelectedUserIndex(id);
  };

  useEffect(() => {
    onSelectUser(0);
  }, [isLoading]);


  return (
    <Flex className="flex-col border bg-white mb-4 rounded-lg pb-2">
      {!isOpen ? (
        <>
          {!viewDetailsIsOpen ? (
            <Flex
              style={{ boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.05)' }}
              className="flex-col p-3 mb-10 items-start justify-between"
            >
              <Box className="flex flex-row mb-4 items-start justify-between">
                <Box minW="100px">
                  <Text
                    color="brand.primary"
                    className={`pt-1 text-2xl font-semibold`}
                  >
                    Connect to Investors
                  </Text>
                </Box>
                <Box
                  onClick={() => {
                    navigate('/investors');
                  }}
                  className={`gap-2 py-1 cursor-pointer items-center font-medium hover:font-semibold ${showViewAll ? 'flex' : 'hidden'}`}
                >
                  <Box className="sm:pr-2 sm:border-r">
                    <img
                      className="h-3.5 w-3.5"
                      src={dashboard}
                      alt="dashboard-icon"
                    />
                  </Box>
                  <Text className="hidden sm:block text-green-800 text-sm">
                    View all
                  </Text>
                  {/* <Filter onChange={updateFilter}  onApply={(data) => {getInvestors({filter:data, append:false})}}/>
                      <SearchBar userType={1} /> */}
                </Box>
              </Box>
              <Collapsible title={'Filters'}>
                <Box className="grid grid-cols-2 sm:flex sm:flex-wrap gap-y-4 gap-x-2 sm:gap-x-4 sm:gap-y-4 my-3 items-center">
                  <NewFilter
                    isFreePlan={SUBSCRIPTION_FLAG == "on" && isFreePlan}
                    reset={resetFilters}
                    multichoice
                    section="Stages"
                    onChange={handleFilterChange}
                    onApply={(data) => {
                      getInvestors({ filter: data, append: false });
                    }}
                    filters={
                      data?.data?.companyStages
                        ? { companyStages: data?.data?.companyStages }
                        : null
                    }
                  />
                  <NewFilter
                    isFreePlan={SUBSCRIPTION_FLAG == "on" && isFreePlan}
                    reset={resetFilters}
                    multichoice
                    section="Funding"
                    onChange={handleFilterChange}
                    onApply={(data) => {
                      getInvestors({ filter: data, append: false });
                    }}
                    filters={
                      data?.data?.fundCategories
                        ? { fundCategories: data?.data?.fundCategories }
                        : null
                    }
                  />
                  <NewFilter
                    isFreePlan={SUBSCRIPTION_FLAG == "on" && isFreePlan}
                    reset={resetFilters}
                    multichoice
                    section="Locations"
                    onChange={handleFilterChange}
                    onApply={(data) => {
                      getInvestors({ filter: data, append: false });
                    }}
                    filters={
                      data?.data?.locations
                        ? { locations: data?.data?.locations }
                        : null
                    }
                  />
                  <NewFilter
                    isFreePlan={SUBSCRIPTION_FLAG == "on" && isFreePlan}
                    reset={resetFilters}
                    multichoice
                    section="Categories"
                    onChange={handleFilterChange}
                    onApply={(data) => {
                      getInvestors({ filter: data, append: false });
                    }}
                    filters={
                      data?.data?.categories
                        ? { categories: data?.data?.categories }
                        : null
                    }
                  />
                  {filterIsActive ? (
                    <Box>
                      <BrandButton
                        text="Reset Filters"
                        onClick={handleResetFilter}
                        colorScheme="blue"
                        w={'100%'}
                        className="w-full max-w-min"
                      />
                    </Box>
                  ) : null}
                </Box>
              </Collapsible>
            </Flex>
          ) : null}
        </>
      ) : null}
      <Box
        ref={investorsContainerRef}
        className={`hide-scroll ${isDesktop ? 'max-h-[calc(90vh-200px)] overflow-y-auto pt-4 md:px-5 pb-5' : ''}`}
      >
        {!isLoading ? (
          <Box className="flex flex-wrap gap-3 items-center px-4 justify-start mx-auto">
            {investors && investors.length > 0 ? (
              <>
                {investors.map((investor, index) => (
                  <Fragment key={index}>
                    <NewSingleInvestor
                      setSelectedFounder={setSelectedFounder}
                      investor={investor}
                      isOpen={viewDetailsIsOpen}
                      onToggle={onToggleViewDetails}
                      subscriptionPlanName={investor?.subscriptionPlanName || null}
                    />
                  </Fragment>
                ))}

                {!showViewAll && (
                  <Box className="w-full mt-5">
                    <PaginationControls
                      currentPage={pageNo}
                      totalPages={Math.ceil(totalUsers / pageSize)}
                      onPageChange={(newPage) => {
                        setPageNo(newPage);
                        getInvestors({ pageNumber: newPage });
                      }}
                    />
                  </Box>
                )}
              </>
            ) : (
              <Flex className="text-center justify-center my-2 w-full">
                No investors available yet!
              </Flex>
            )}
          </Box>
        ) : (
          <Spinner />
        )}
      </Box>
    </Flex>
  );
};
export default InvestorList;
